import { memo } from 'react';

import { usePlayerPlayPause, usePlayerStore } from '@air/component-player';
import { VisuallyHidden } from '@air/primitive-visually-hidden';

export const VideoVisualizerPlayPauseOverlay = memo(() => {
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { onPlayerPlayPause, playing } = usePlayerPlayPause();

  return (
    <button
      className="absolute inset-0 z-10 flex size-full cursor-default bg-transparent"
      disabled={!videoElement}
      onClick={onPlayerPlayPause}
      type="button"
    >
      <VisuallyHidden>{playing ? 'Pause' : 'Play'} video</VisuallyHidden>
    </button>
  );
});

VideoVisualizerPlayPauseOverlay.displayName = 'VideoVisualizerPlayPauseOverlay';
